import { providerInView as providerInViewUtil } from '@indeed/mosaic-provider-utils/dist/common-statics/_internal/providerInView';
// Notifies via the callback function the first time a provider comes into the viewport, lazy loading IntersectionObserver
// as needed.
export const providerInView = (providerEl, callback) => {
    return 'IntersectionObserver' in window
        ? // eslint-disable-next-line compat/compat
            Promise.resolve(providerInViewUtil(window.IntersectionObserver, providerEl, callback))
        : Promise.resolve();
};
